import { render, staticRenderFns } from "./AddPrintNotes.vue?vue&type=template&id=203401a3&"
import script from "./AddPrintNotes.vue?vue&type=script&lang=ts&"
export * from "./AddPrintNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203401a3')) {
      api.createRecord('203401a3', component.options)
    } else {
      api.reload('203401a3', component.options)
    }
    module.hot.accept("./AddPrintNotes.vue?vue&type=template&id=203401a3&", function () {
      api.rerender('203401a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/AddPrintNotes.vue"
export default component.exports